<template>
    <div class="container" v-show="show">
        <div class="box-share">
            <div class="model"></div>
            <div class="box-content">
                <div class="box-title">{{ title }}</div>
                <div class="btn-container">
                    <div class="btn-container-content">
                        <div class="tip">{{ content }}</div>
                    </div>
                    <div class="footer">
                        <div class="give-up btn" v-if="lefttxt" @click="giveupBtn">{{ lefttxt }}</div>
                        <div class="continue btn" :class="{'height41': !lefttxt}" @click="continueBtn">{{ righttxt }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'homeDialog',
    props: ['show', 'title', 'content', 'lefttxt', 'righttxt'],

    methods: {
        giveupBtn() {
            this.$emit('giveupBtn');
        },
        continueBtn() {
            this.$emit('continueBtn');
        }
    }
};
</script>
<style lang="less" scoped>

.container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    z-index: 1111;
    justify-content: center;
    align-items: center;
}

.box-share {
    z-index: 1;

    .box-content {
        z-index: 1;
        width: 303px;
        display: flex;
        border-radius: 8px;
        flex-direction: column;
        align-items: center;
        background-color: #fff;

        .box-title {
            margin: 30px 24px 17px;
            font-size: 16px;
            font-weight: 600;
            color: #002A3C;
            line-height: 24px;
            text-align: center;
        }

        .btn-container {
            width: 100%;

            &-content {
                width: 255px;
                border-radius: 4px;
                margin-left: auto;
                margin-right: auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                background-size: contain;
                text-align: left;

                .tip {
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 22px;
                    color: #49596C;
                    word-break: break-all;
                }
            }

            .footer {
                display: flex;
                justify-content: space-between;
                padding: 30px 24px 22px;

                .btn {
                    flex: 1;
                    height: 36px;
                    border-radius: 8px;
                    line-height: 36px;
                    text-align: center;
                    font-size: 16px;
                    font-weight: 600;
                }

                .give-up {
                    border: 1px solid #DCE1E6;
                    color: #616B78;
                    margin-right: 20px;
                }

                .continue {
                    background: linear-gradient(270deg, #3CA5E2 0%, #4DBAF9 100%);
                    color: #FFFFFF;
                }

                .height41 {
                    height: 41px;
                    line-height: 41px;
                }
            }
        }
    }
}
</style>
